import { Component, NgZone, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'app/services/http.service';
import { validateRut, formatterRut, numberToClp } from 'chilean-formatter';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-guardias',
  templateUrl: './guardias.component.html',
  styleUrls: ['./guardias.component.scss']
})
export class GuardiasComponent implements OnInit {

  usuario: any;
  guardias: any[];
  estaEditando: boolean = false;
  modoCreaEdita: boolean = false;
  formulario: FormGroup;
  estadosCiviles: any[];

  regiones: any[];
  comunas: any[];
  regionescomunas: any[];
  comunasFiltradas: any[];

  tipoDocumento: string = 'nacional'

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private http: HttpService,
    private ngZone: NgZone,
  ) {

    this.usuario = JSON.parse(this.http.getLocalstorage('usuario'))

    this.formulario = this.formBuilder.group({
      _id: '',
      Rut: ['', Validators.required],
      Nombre: ['', Validators.required],
      Direccion: '',
      Fono: '',
      Nacionalidad: '',

      FechaNacimiento: '',
      Prevision: '',
      Salud: '',
      FechaIngreso: '',
      FechaTermino: '',
      EstadoCursoOS10: '',

      TallaCamisa: '',
      TallaPantalon: '',
      TallaCalzado: '',

      Habilitado: true,

    });

    this.estadosCiviles = [
      { id: 0, estado: 'SOLTERO' },
      { id: 1, estado: 'CASADO' },
      { id: 1, estado: 'VIUDO' },
      { id: 1, estado: 'DIVORCIADO' },
    ]

    this.getGuardias();
  }

  async ngOnInit(): Promise<void> {

  }

  cambiaTipoDocumento(tipo) {
    console.log('event', tipo);
    this.formulario.controls.Rut.reset();
  }

  nuevo() {
    console.log('pasṕ por nuevo');

    this.estaEditando = false
    this.modoCreaEdita = true

    console.log('this.estaEditando', this.estaEditando);

  }

  delete(event: Event, id) {
    console.log('delete');
    console.log('id', id);
    this.confirmationService.confirm({
      target: event.target,
      message: 'Está seguro?',
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'No',
      acceptLabel: 'Si, eliminar',
      accept: () => {
        this.http.deleteGuardiaService(id)
          .subscribe((data: any) => {
            console.log(data);
            this.getGuardias();
          })
        this.messageService.add({
          severity: "info",
          summary: "Listo",
          detail: "..se nos fue uno!!"
        });
      },
      reject: () => {
        return;
      }
    });

  }

  guardar(_formValue) {

    let formValue = JSON.parse(JSON.stringify(_formValue))
    formValue.Empresa = this.usuario.Empresa._id

    console.log('formValue', formValue);

    if (this.estaEditando) {

      this.http.updateGuardiaService(formValue).subscribe((data: any) => {
        console.log('data', data);
        this.getGuardias()
        this.messageService.add({
          severity: 'success',
          summary: 'Listo!',
          detail: 'Registro editado'
        });

        this.modoCreaEdita = false;
        this.estaEditando = false;

        this.limpiaFormulario()
      }, err => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: err.error
        });
      })

      return;
    }

    this.http.newGuardiaService(formValue).subscribe((data: any) => {
      console.log('data', data);
      this.getGuardias()
      this.messageService.add({
        severity: 'success',
        summary: 'Listo!',
        detail: 'Registro creado'
      });

      this.modoCreaEdita = false;
      this.limpiaFormulario()
    }, err => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error!',
        detail: err.error
      });
    })

  }

  async getGuardias(): Promise<void> {
    this.guardias = await this.http.getguardiasbyEmpresaService(this.usuario.Empresa._id);
    console.log('guardias', this.guardias);

    this.ngZone.run(() => { })

  }

  formateaRUT() {
    this.formulario.controls.Rut.setValue(formatterRut(this.formulario.controls.Rut.value))

    if (!validateRut(this.formulario.controls.Rut.value))
      this.formulario.controls.Rut.setErrors({ 'incorrect': true })
  }

  abreModaledita(id) {
    console.log('id:', id);

    this.estaEditando = true
    this.modoCreaEdita = true
    let index = this.guardias.findIndex(e => e._id == id)

    let guardia = this.guardias[index]
    console.log('guardia', guardia);

    this.formulario.patchValue(guardia)
  }


  limpiaFormulario() {
    this.formulario.reset()
    this.modoCreaEdita = false
    this.estaEditando = false
  }


}
